import { render, staticRenderFns } from "./icons-render.vue?vue&type=template&id=e0b3147c&scoped=true&"
import script from "../../js/widgets/icons-render.js?vue&type=script&lang=js&"
export * from "../../js/widgets/icons-render.js?vue&type=script&lang=js&"
import style0 from "./icons-render.vue?vue&type=style&index=0&id=e0b3147c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b3147c",
  null
  
)

export default component.exports